import { render, staticRenderFns } from "./GradesChart.vue?vue&type=template&id=4fead61a&scoped=true&"
import script from "./GradesChart.vue?vue&type=script&lang=js&"
export * from "./GradesChart.vue?vue&type=script&lang=js&"
import style0 from "./GradesChart.vue?vue&type=style&index=0&id=4fead61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fead61a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fead61a', component.options)
    } else {
      api.reload('4fead61a', component.options)
    }
    module.hot.accept("./GradesChart.vue?vue&type=template&id=4fead61a&scoped=true&", function () {
      api.rerender('4fead61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/home/GradesChart.vue"
export default component.exports